// import "./update.scss";
// import Sidebar from "../../components/sidebar/Sidebar";
// import Navbar from "../../components/navbar/Navbar";
// import { useState, useEffect } from "react";
// import Select from "react-select";
// import { useLocation, useNavigate } from "react-router-dom";
// import { serverUrl } from "../../temp";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { studentattendanceInputs } from "../../formSource";

// const statusOptions = [
//   { value: 0, label: "Absent" },
//   { value: 1, label: "Present" },
//   { value: 2, label: "Late" },
//   { value: 3, label: "Leave" },
//   { value: 4, label: "Half Leave" },
// ];

// const StudentAttendanceUpdate = ({ title }) => {
//   const location = useLocation();
//   const attendanceId = location.pathname.match(
//     /\/update-student-attendance\/(\d+)/
//   )?.[1];

//   const navigate = useNavigate();
//   const [inputValues, setInputValues] = useState({
//     attendance_date: "",
//     user_id: null,
//     student_id: null,
//     class_id: null,
//     subject_id: null,
//     status: null,
//   });

//   const [selectedUser, setSelectedUser] = useState(null);
//   const [selectedAdmin, setSelectedAdmin] = useState(null);
//   const [selectedStudent, setSelectedStudent] = useState(null);
//   const [selectedClass, setSelectedClass] = useState(null);
//   const [selectedSubject, setSelectedSubject] = useState(null);
//   const [selectedStatus, setSelectedStatus] = useState(null);

//   const [userOptions, setUserOptions] = useState([]);
//   const [studentOptions, setStudentOptions] = useState([]);
//   const [classOptions, setClassOptions] = useState([]);
//   const [subjectOptions, setSubjectOptions] = useState([
//     { value: 0, label: "General" },
//   ]);

//   const center_id = localStorage.getItem("center_id");
//   const [token] = useState(localStorage.getItem("token"));

//   const redirectToLogin = () => {
//     alert("Please login first to access this page...");
//     window.location.href = "/";
//   };

//   // Fetch dropdown options
//   useEffect(() => {
//     const fetchDropdownData = async () => {
//       try {
//         // Fetch teachers
//         const teachersRes = await fetch(`${serverUrl}/user_ids/${center_id}`);
//         const teachersData = await teachersRes.json();
//         setUserOptions(
//           teachersData.data.map((t) => ({ value: t.id, label: t.name }))
//         );

//         // Fetch classes
//         const classesRes = await fetch(`${serverUrl}/class_ids/${center_id}`);
//         const classesData = await classesRes.json();
//         setClassOptions(
//           classesData.data.map((c) => ({ value: c.id, label: c.name }))
//         );

//         // Fetch subjects
//         const subjectsRes = await fetch(
//           `${serverUrl}/subject_ids/${center_id}`
//         );
//         const subjectsData = await subjectsRes.json();
//         setSubjectOptions([
//           { value: 0, label: "General" },
//           ...subjectsData.data.map((s) => ({ value: s.id, label: s.name })),
//         ]);

//         // Fetch students
//         const studentsRes = await fetch(
//           `${serverUrl}/student_ids/${center_id}`
//         );
//         const studentsData = await studentsRes.json();
//         setStudentOptions(
//           studentsData.data.map((s) => ({
//             value: { id: s.id, class_id: s.class_id },
//             label: `${s.name} (${s.class_name})`,
//             class_id: s.class_id,
//           }))
//         );
//       } catch (error) {
//         console.error("Error fetching dropdown data:", error);
//       }
//     };

//     fetchDropdownData();
//   }, [center_id]);

//   // Fetch existing attendance record
//   useEffect(() => {
//     const fetchAttendance = async () => {
//       try {
//         const response = await fetch(
//           `${serverUrl}/student_attendance/${attendanceId}`
//         );
//         if (!response.ok) {
//           throw new Error("Failed to fetch attendance record");
//         }
//         const data = await response.json();

//         // Format the date properly
//         const attendanceDate = data.data.attendance_date
//           ? new Date(data.data.attendance_date).toISOString().split("T")[0]
//           : "";

//         // Set form values from fetched data
//         setInputValues({
//           ...data.data,
//           attendance_date: attendanceDate,
//           subject_id: data.data.subject_id == null ? 0 : data.data.subject_id,
//         });

//         // Set selected options
//         if (data.data.user_id) {
//           const user = {
//             value: data.data.user_id,
//             label: data.data.user_name,
//           };
//           setSelectedUser(user);
//         }
//         if (data.data.admin_id) {
//           const user = {
//             value: data.data.admin_id,
//             label: data.data.admin_name,
//           };
//           setSelectedAdmin(user);
//         }
//         if (data.data.student_id) {
//           const student = {
//             value: { id: data.data.student_id, class_id: data.data.class_id },
//             label: `${data.data.student_name} (${data.data.class_name})`,
//           };
//           setSelectedStudent(student);
//         }

//         if (data.data.class_id) {
//           const classOpt = {
//             value: data.data.class_id,
//             label: data.data.class_name,
//           };
//           setSelectedClass(classOpt);
//         }

//         // Handle subject selection
//         const subjectValue =
//           data.data.subject_id === null ? 0 : data.data.subject_id;
//         const subjectLabel = data.data.subject_name || "General";
//         setSelectedSubject({
//           value: subjectValue,
//           label: subjectLabel,
//         });

//         if (data.data.status !== undefined) {
//           const status = statusOptions.find(
//             (opt) => opt.value === data.data.status
//           );
//           setSelectedStatus(status);
//         }
//       } catch (error) {
//         console.error("Error fetching attendance:", error);
//         toast.error("Failed to load attendance data");
//       }
//     };

//     if (attendanceId) {
//       fetchAttendance();
//     }
//   }, [attendanceId]);

//   const handleInputChange = (e) => {
//     setInputValues({
//       ...inputValues,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleUserSelectChange = (selectedOption) => {
//     setSelectedUser(selectedOption);
//     setInputValues({
//       ...inputValues,
//       user_id: selectedOption?.value || null,
//     });
//   };

//   const handleAdminSelectChange = (selectedOption) => {
//     setSelectedAdmin(selectedOption);
//     setInputValues({
//       ...inputValues,
//       admin_id: selectedOption?.value || null,
//     });
//   };

//   const handleStudentSelectChange = (selectedOption) => {
//     setSelectedStudent(selectedOption);
//     const classOpt = classOptions.find(
//       (opt) => opt.value === selectedOption.value.class_id
//     );
//     setSelectedClass(classOpt);
//     setInputValues({
//       ...inputValues,
//       student_id: selectedOption?.value?.id || null,
//       class_id: selectedOption?.value?.class_id || null,
//     });
//   };

//   const handleClassSelectChange = (selectedOption) => {
//     setSelectedClass(selectedOption);
//     setInputValues({
//       ...inputValues,
//       class_id: selectedOption?.value || null,
//     });
//   };

//   const handleSubjectSelectChange = (selectedOption) => {
//     setSelectedSubject(selectedOption);
//     setInputValues({
//       ...inputValues,
//       subject_id: selectedOption?.value === 0 ? null : selectedOption?.value,
//     });
//   };
//   // In the handleStatusSelectChange function, ensure it updates both states:
//   const handleStatusSelectChange = (selectedOption) => {
//     setSelectedStatus(selectedOption);
//     setInputValues({
//       ...inputValues,
//       status: selectedOption ? selectedOption.value : null, // Ensure proper null handling
//     });
//   };

//   // In the handleSubmit function, add debugging:
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // Debug log to check all values before submission
//     console.log("Submitting with values:", {
//       ...inputValues,
//       status: inputValues.status,
//       selectedStatus: selectedStatus,
//     });

//     const formData = new FormData();
//     formData.append("center_id", localStorage.getItem("center_id"));
//     formData.append("user_id", inputValues.user_id);
//     formData.append("student_id", inputValues.student_id);
//     formData.append("class_id", inputValues.class_id);
//     formData.append("subject_id", inputValues.subject_id);
//     formData.append("admin_id", inputValues.admin_id);
//     formData.append("attendance_date", inputValues.attendance_date);
//     formData.append("status", inputValues.status); // Ensure this is the correct value

//     // Rest of your submit logic...
//     try {
//       const response = await fetch(
//         `${serverUrl}/upd_student_attendance/${attendanceId}`,
//         {
//           method: "PUT",
//           body: formData,
//         }
//       );

//       const data = await response.json();

//       if (data.code >= 400) {
//         if (typeof data.message === "object") {
//           Object.entries(data.message).forEach(([field, errors]) => {
//             errors.forEach((errMsg) => {
//               toast.error(`${field}: ${errMsg}`);
//             });
//           });
//         } else {
//           toast.error(data.message || "Something went wrong.");
//         }
//       } else {
//         toast.success("Attendance updated successfully!");
//         setTimeout(() => {
//           navigate("/student-attendance");
//         }, 1000);
//       }
//     } catch (error) {
//       console.error(error);
//       toast.error("Failed to update attendance");
//     }
//   };

//   return (
//     <>
//       {!token && redirectToLogin()}
//       {token && (
//         <div className="update">
//           <Sidebar />
//           <div className="updateContainer">
//             <Navbar />
//             <div className="top">
//               <h1>{title}</h1>
//             </div>
//             <div className="bottom">
//               <div className="right">
//                 <form onSubmit={handleSubmit}>
//                   {studentattendanceInputs.map((input) => (
//                     <div className="formInput" key={input.id}>
//                       <label>{input.label}</label>
//                       {input.fieldName === "attendance_date" ? (
//                         <input
//                           type={input.type}
//                           name={input.fieldName}
//                           value={inputValues[input.fieldName] || ""}
//                           onChange={handleInputChange}
//                           required={input.required}
//                         />
//                       ) : input.fieldName === "admin_id" ? (
//                         <Select
//                           options={userOptions}
//                           value={selectedAdmin}
//                           onChange={handleAdminSelectChange}
//                           required={input.required}
//                         />
//                       ) : input.fieldName === "user_id" ? (
//                         <Select
//                           options={userOptions}
//                           value={selectedUser}
//                           onChange={handleUserSelectChange}
//                           required={input.required}
//                         />
//                       ) : input.fieldName === "student_id" ? (
//                         <Select
//                           options={studentOptions}
//                           value={selectedStudent}
//                           onChange={handleStudentSelectChange}
//                           required={input.required}
//                         />
//                       ) : input.fieldName === "class_id" ? (
//                         <Select
//                           options={classOptions}
//                           value={selectedClass}
//                           onChange={handleClassSelectChange}
//                           isDisabled={true}
//                           required={input.required}
//                         />
//                       ) : input.fieldName === "subject_id" ? (
//                         <Select
//                           options={subjectOptions}
//                           value={selectedSubject}
//                           onChange={handleSubjectSelectChange}
//                           required={input.required}
//                         />
//                       ) : input.fieldName === "status" ? (
//                         <Select
//                           options={statusOptions}
//                           value={selectedStatus}
//                           onChange={handleStatusSelectChange}
//                           required={input.required}
//                         />
//                       ) : (
//                         <input
//                           type={input.type}
//                           name={input.fieldName}
//                           value={inputValues[input.fieldName] || ""}
//                           onChange={handleInputChange}
//                           required={input.required}
//                         />
//                       )}
//                     </div>
//                   ))}

//                   <div style={{ clear: "both" }} className="formUpdate">
//                     <button type="submit" style={{ float: "right" }}>
//                       Update
//                     </button>
//                     <button
//                       type="button"
//                       style={{ float: "right", marginRight: "10px" }}
//                       onClick={() => navigate("/student-attendance")}
//                     >
//                       Cancel
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//       <ToastContainer position="top-right" autoClose={3000} />
//     </>
//   );
// };

// export default StudentAttendanceUpdate;
import React, { useState, useEffect } from "react";
import Select from "react-select";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { studentattendanceInputs } from "../../formSource";
import { useLocation, useNavigate } from "react-router-dom";
import { serverUrl } from "../../temp";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import "./update.scss";

const theme = createTheme({
  palette: {
    primary: {
      main: "#7451f8",
    },
    secondary: {
      main: "#6c757d",
    },
  },
});

const statusOptions = [
  { value: 0, label: "Absent" },
  { value: 1, label: "Present" },
  { value: 2, label: "Late" },
  { value: 3, label: "Leave" },
  { value: 4, label: "Half Leave" },
];

const StudentAttendanceUpdate = ({ title }) => {
  const location = useLocation();
  const attendanceId = location.pathname.match(/\/update-student-attendance\/(\d+)/)?.[1];
  const navigate = useNavigate();
  const center_id = localStorage.getItem("center_id");
  const [token] = useState(localStorage.getItem("token"));

  const [inputValues, setInputValues] = useState({
    attendance_date: "",
    user_id: null,
    student_id: null,
    class_id: null,
    subject_id: null,
    status: null,
  });

  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [selectedClass, setSelectedClass] = useState(null);
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);

  const [userOptions, setUserOptions] = useState([]);
  const [studentOptions, setStudentOptions] = useState([]);
  const [classOptions, setClassOptions] = useState([]);
  const [subjectOptions, setSubjectOptions] = useState([
    { value: 0, label: "General" },
  ]);

  const redirectToLogin = () => {
    alert("Please login first to access this page...");
    window.location.href = "/";
  };

  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        // Fetch teachers
        const teachersRes = await fetch(`${serverUrl}/user_ids/${center_id}`);
        const teachersData = await teachersRes.json();
        setUserOptions(
          teachersData.data.map((t) => ({ value: t.id, label: t.name }))
        );

        // Fetch classes
        const classesRes = await fetch(`${serverUrl}/class_ids/${center_id}`);
        const classesData = await classesRes.json();
        setClassOptions(
          classesData.data.map((c) => ({ value: c.id, label: c.name }))
        );

        // Fetch subjects
        const subjectsRes = await fetch(`${serverUrl}/subject_ids/${center_id}`);
        const subjectsData = await subjectsRes.json();
        setSubjectOptions([
          { value: 0, label: "General" },
          ...subjectsData.data.map((s) => ({ value: s.id, label: s.name })),
        ]);

        // Fetch students
        const studentsRes = await fetch(`${serverUrl}/student_ids/${center_id}`);
        const studentsData = await studentsRes.json();
        setStudentOptions(
          studentsData.data.map((s) => ({
            value: { id: s.id, class_id: s.class_id },
            label: `${s.name} (${s.class_name})`,
            class_id: s.class_id,
          }))
        );
      } catch (error) {
        console.error("Error fetching dropdown data:", error);
        toast.error("Failed to fetch dropdown options");
      }
    };

    fetchDropdownData();
  }, [center_id]);

  useEffect(() => {
    const fetchAttendance = async () => {
      try {
        const response = await fetch(`${serverUrl}/student_attendance/${attendanceId}`);
        if (!response.ok) {
          throw new Error("Failed to fetch attendance record");
        }
        const data = await response.json();

        // Format the date properly
        const attendanceDate = data.data.attendance_date
          ? new Date(data.data.attendance_date).toISOString().split("T")[0]
          : "";

        // Set form values from fetched data
        setInputValues({
          ...data.data,
          attendance_date: attendanceDate,
          subject_id: data.data.subject_id == null ? 0 : data.data.subject_id,
        });

        // Set selected options
        if (data.data.user_id) {
          setSelectedUser({
            value: data.data.user_id,
            label: data.data.user_name,
          });
        }
        if (data.data.admin_id) {
          setSelectedAdmin({
            value: data.data.admin_id,
            label: data.data.admin_name,
          });
        }
        if (data.data.student_id) {
          setSelectedStudent({
            value: { id: data.data.student_id, class_id: data.data.class_id },
            label: `${data.data.student_name} (${data.data.class_name})`,
          });
        }

        if (data.data.class_id) {
          setSelectedClass({
            value: data.data.class_id,
            label: data.data.class_name,
          });
        }

        // Handle subject selection
        const subjectLabel = data.data.subject_name || "General";
        setSelectedSubject({
          value: data.data.subject_id === null ? 0 : data.data.subject_id,
          label: subjectLabel,
        });

        if (data.data.status !== undefined) {
          setSelectedStatus(
            statusOptions.find((opt) => opt.value === data.data.status)
          );
        }
      } catch (error) {
        console.error("Error fetching attendance:", error);
        toast.error("Failed to load attendance data");
      }
    };

    if (attendanceId) {
      fetchAttendance();
    }
  }, [attendanceId]);

  const handleInputChange = (e) => {
    setInputValues({
      ...inputValues,
      [e.target.name]: e.target.value,
    });
  };

  const handleUserSelectChange = (selectedOption) => {
    setSelectedUser(selectedOption);
    setInputValues({
      ...inputValues,
      user_id: selectedOption?.value || null,
    });
  };

  const handleAdminSelectChange = (selectedOption) => {
    setSelectedAdmin(selectedOption);
    setInputValues({
      ...inputValues,
      admin_id: selectedOption?.value || null,
    });
  };

  const handleStudentSelectChange = (selectedOption) => {
    setSelectedStudent(selectedOption);
    const classOpt = classOptions.find(
      (opt) => opt.value === selectedOption.value.class_id
    );
    setSelectedClass(classOpt);
    setInputValues({
      ...inputValues,
      student_id: selectedOption?.value?.id || null,
      class_id: selectedOption?.value?.class_id || null,
    });
  };

  const handleClassSelectChange = (selectedOption) => {
    setSelectedClass(selectedOption);
    setInputValues({
      ...inputValues,
      class_id: selectedOption?.value || null,
    });
  };

  const handleSubjectSelectChange = (selectedOption) => {
    setSelectedSubject(selectedOption);
    setInputValues({
      ...inputValues,
      subject_id: selectedOption?.value === 0 ? null : selectedOption?.value,
    });
  };

  const handleStatusSelectChange = (selectedOption) => {
    setSelectedStatus(selectedOption);
    setInputValues({
      ...inputValues,
      status: selectedOption ? selectedOption.value : null,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("center_id", center_id);
    formData.append("user_id", inputValues.user_id);
    formData.append("student_id", inputValues.student_id);
    formData.append("class_id", inputValues.class_id);
    formData.append("subject_id", inputValues.subject_id);
    formData.append("admin_id", inputValues.admin_id);
    formData.append("attendance_date", inputValues.attendance_date);
    formData.append("status", inputValues.status);

    try {
      const response = await fetch(
        `${serverUrl}/upd_student_attendance/${attendanceId}`,
        {
          method: "PUT",
          body: formData,
        }
      );

      const data = await response.json();

      if (data.code >= 400) {
        if (typeof data.message === "object") {
          Object.entries(data.message).forEach(([field, errors]) => {
            errors.forEach((errMsg) => {
              toast.error(`${field}: ${errMsg}`);
            });
          });
        } else {
          toast.error(data.message || "Something went wrong.");
        }
      } else {
        toast.success("Attendance updated successfully!");
        setTimeout(() => {
          navigate("/student-attendance");
        }, 1000);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to update attendance");
    }
  };

  return (
    <ThemeProvider theme={theme}>
      {!token && redirectToLogin()}
      {token && (
        <div className="update">
          <Sidebar />
          <div className="updateContainer">
            <Navbar />
            <div className="contentWrapper">
              <Card className="formCard">
                <CardContent className="cardContent">
                  <Typography variant="h5" component="h2" gutterBottom className="formTitle">
                    {title}
                  </Typography>
                  <form onSubmit={handleSubmit} className="responsiveForm">
                    <Grid container spacing={2}>
                      {studentattendanceInputs.map((input) => (
                        <Grid item xs={12} sm={6} key={input.id} className="formGridItem">
                          <div className="formInput">
                            <label>{input.label}</label>
                            {input.fieldName === "attendance_date" ? (
                              <input
                                type={input.type}
                                name={input.fieldName}
                                value={inputValues[input.fieldName] || ""}
                                onChange={handleInputChange}
                                required={input.required}
                              />
                            ) : input.fieldName === "admin_id" ? (
                              <Select
                                options={userOptions}
                                value={selectedAdmin}
                                onChange={handleAdminSelectChange}
                                required={input.required}
                                className="selectInput"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: '46px',
                                    borderColor: '#e2e8f0',
                                    '&:hover': {
                                      borderColor: '#cbd5e0'
                                    }
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: '2px 8px'
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    margin: '0',
                                    padding: '0'
                                  }),
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    height: '44px'
                                  })
                                }}
                              />
                            ) : input.fieldName === "user_id" ? (
                              <Select
                                options={userOptions}
                                value={selectedUser}
                                onChange={handleUserSelectChange}
                                required={input.required}
                                className="selectInput"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: '46px',
                                    borderColor: '#e2e8f0',
                                    '&:hover': {
                                      borderColor: '#cbd5e0'
                                    }
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: '2px 8px'
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    margin: '0',
                                    padding: '0'
                                  }),
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    height: '44px'
                                  })
                                }}
                              />
                            ) : input.fieldName === "student_id" ? (
                              <Select
                                options={studentOptions}
                                value={selectedStudent}
                                onChange={handleStudentSelectChange}
                                required={input.required}
                                className="selectInput"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: '46px',
                                    borderColor: '#e2e8f0',
                                    '&:hover': {
                                      borderColor: '#cbd5e0'
                                    }
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: '2px 8px'
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    margin: '0',
                                    padding: '0'
                                  }),
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    height: '44px'
                                  })
                                }}
                              />
                            ) : input.fieldName === "class_id" ? (
                              <Select
                                options={classOptions}
                                value={selectedClass}
                                onChange={handleClassSelectChange}
                                isDisabled={true}
                                required={input.required}
                                className="selectInput"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: '46px',
                                    borderColor: '#e2e8f0',
                                    '&:hover': {
                                      borderColor: '#cbd5e0'
                                    }
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: '2px 8px'
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    margin: '0',
                                    padding: '0'
                                  }),
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    height: '44px'
                                  })
                                }}
                              />
                            ) : input.fieldName === "subject_id" ? (
                              <Select
                                options={subjectOptions}
                                value={selectedSubject}
                                onChange={handleSubjectSelectChange}
                                required={input.required}
                                className="selectInput"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: '46px',
                                    borderColor: '#e2e8f0',
                                    '&:hover': {
                                      borderColor: '#cbd5e0'
                                    }
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: '2px 8px'
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    margin: '0',
                                    padding: '0'
                                  }),
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    height: '44px'
                                  })
                                }}
                              />
                            ) : input.fieldName === "status" ? (
                              <Select
                                options={statusOptions}
                                value={selectedStatus}
                                onChange={handleStatusSelectChange}
                                required={input.required}
                                className="selectInput"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: '46px',
                                    borderColor: '#e2e8f0',
                                    '&:hover': {
                                      borderColor: '#cbd5e0'
                                    }
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: '2px 8px'
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    margin: '0',
                                    padding: '0'
                                  }),
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    height: '44px'
                                  })
                                }}
                              />
                            ) : (
                              <input
                                type={input.type}
                                name={input.fieldName}
                                value={inputValues[input.fieldName] || ""}
                                onChange={handleInputChange}
                                required={input.required}
                              />
                            )}
                          </div>
                        </Grid>
                      ))}
                    </Grid>
                    <Box sx={{ display: "flex", justifyContent: "center", gap: 3, mt: 4, pb: 2 }}>
                      <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() => navigate("/student-attendance")}
                        sx={{ minWidth: '120px', height: '42px' }}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        sx={{ minWidth: '150px', height: '42px' }}
                      >
                        Update Attendance
                      </Button>
                    </Box>
                  </form>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      )}
      <ToastContainer position="top-right" autoClose={3000} />
    </ThemeProvider>
  );
};

export default StudentAttendanceUpdate;